import React from "react";
import videoSrc from "../assets/init.mp4";
import { products } from "../data/products";
import ProductCard from "../components/ProductCard";
import BackgroundVideo from "../components/BackgroundVideo";

function Home() {
  return (
    <div className="bg-custom-background min-h-screen">
      <BackgroundVideo videoSrc={videoSrc} />

      {/* Sección de productos */}
      <div className="p-8 flex justify-center">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-8">
          {products.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
